import axios from "axios";
import {onDomChanges} from "../../components/dynamic/observer";

function initForms() {
  document.querySelectorAll('[data-manager-post-form]').forEach((formEl) => {
    if (formEl.dataset.inited) {
      return;
    }
    formEl.dataset.inited = 'true';
    formEl.querySelector('input').addEventListener('change', () => {
      const formData = new FormData(formEl);
      axios({
        method: "post",
        url: formEl.getAttribute('action'),
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
    })
    formEl.addEventListener('submit', (e) => {
      e.preventDefault();
      const formData = new FormData(formEl);
      axios({
        method: "post",
        url: formEl.getAttribute('action'),
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
    });
  });

  document.querySelectorAll('[data-manager-form]').forEach((formEl) => {
    async function sendForm(formEl) {
      formEl.classList.add('_loading');
      const formData = new FormData(formEl);
      const response = await axios({
        method: "post",
        url: formEl.getAttribute('action'),
        data: formData,
        headers: {"Content-Type": "multipart/form-data"},
      });
      formEl.classList.remove('_loading');
      const data = response.data;
      if (data.status === 'error') {
        alert(data.message);
      } else {
        alert(data.message);
        window.location.reload();
      }
    }
    formEl.addEventListener('submit', (e) => {
      e.preventDefault();
      sendForm(formEl);
    });
  });

  document.querySelectorAll('[data-marks-form]').forEach((formEl) => {
    if (formEl.dataset.inited) {
      return;
    }
    formEl.dataset.inited = 'true';
    async function sendForm(formEl) {
      formEl.classList.add('_loading');
      const formData = new FormData(formEl);
      const response = await axios({
        method: "post",
        url: formEl.getAttribute('action'),
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      formEl.classList.remove('_loading');
      const data = response.data;
      if (data.status === 'error') {
        alert(data.message);
      } else {
        // Жмем галочку марки ушли
        const row = formEl.closest('[data-order-row]');
        const inputSent = row.querySelector('[name="sent"]');
        if (inputSent) {
          inputSent.checked = 'checked';
          setTimeout(() => {
            inputSent.dispatchEvent(new Event('change', {
              bubbles: true,
              cancelable: true,
            }));
          }, 100);
        }
        const marks = row.querySelector('.marks');
        marks.classList.toggle('_opened');
      }
    }

    formEl.addEventListener('submit', (e) => {
      e.preventDefault();
      sendForm(formEl);
    });
  })
}

function submitForm(jsFilterForm) {
  const loader = document.querySelector('[data-loader]');
  loader.classList.add('_visible');
  const formData = new FormData(jsFilterForm);
  const urlSearchParams = new URLSearchParams();

  for (const [key, value] of formData.entries()) {
    urlSearchParams.append(key, value);
  }

  const queryString = urlSearchParams.toString();
  const actionUrl = jsFilterForm.action + '?' + queryString;
  let replaceContent = document.querySelector('[data-replace-content]');
  fetch(actionUrl, {
    method: 'GET',
  })
      .then(response => response.text())
      .then((response) => {
        const page = document.createElement('div');
        page.innerHTML = response;
        replaceContent.innerHTML = page.querySelector('[data-replace-content]').innerHTML;

        // Убираем прелоадер
        loader.classList.remove('_visible');

        // Диспатчим изменения фильтра
        let event = new Event('DOMContentMutated');
        document.dispatchEvent(event);
      })
      .catch(err => console.log(err))
}

const jsFilterForm = document.querySelector('[data-js-filter-form]');
if (jsFilterForm) {
  jsFilterForm.querySelectorAll('[data-filter-by]').forEach((inputEl) => {
    // initJsFilterFormElement(inputEl);

    inputEl.addEventListener('change', () => {
      submitForm(jsFilterForm);
    })
  });

  jsFilterForm.addEventListener('submit', (e) => {
    e.preventDefault();
    submitForm(jsFilterForm);
  })
}
onDomChanges(() => {
  initForms();
});

const printMarksForm = document.querySelector('[data-print-marks-form]');
if (printMarksForm) {
  printMarksForm.addEventListener('submit', (e) => {
    setTimeout(() => {
      window.location.reload();
    }, 300);
  })
}